import angular from 'angular';

import IconPaletteComponent from './icon-palette.cmpt';

export default angular
    .module('application.component.modals.component.category-edit-modal.component.icon-palette', [])
    .component(IconPaletteComponent.selector, IconPaletteComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/component/icon-palette/index.js